import React from 'react'
import useEmployeeSearch from './hooks/useEmployeeSearch'
import { SearchDropdown, Avatar, HighlightedText, Flex } from '@ui'
import track from '@track'
import Event from '@track/Event'
import { IEmployee } from '@api'

export default function EmployeeSearch({
  navigate,
  queryTable,
}: {
  navigate?: (to: string) => void
  queryTable: (query: string) => void
}) {
  const search = useEmployeeSearch()
  const onSelect = (employee: IEmployee) => {
    navigate && employee && navigate(`?employeeId=${employee.id}`)
    track.employees({
      eventName: Event.SEARCH_RESULT_CLICK,
    })
  }

  return (
    <SearchDropdown
      {...{
        'data-input': 'employee_search',
        search,
        queryTable,
        onSelect,
        width: '400px',
        test: 'employee_search',
      }}
      renderItem={(employee: IEmployee) => (
        <EmployeeItem employee={employee} query={search.query} />
      )}
    />
  )
}

const EmployeeItem = ({ employee, query }: { employee: IEmployee; query: string }) => (
  <Flex align="center">
    <Avatar size={Avatar.Size.XS} name={employee.name} assets={employee.assets} />
    <div style={{ marginLeft: 10 }}>
      <HighlightedText test="employee_search_item" text={employee.name} query={query} />
      <div
        style={{
          fontSize: 12,
          lineHeight: '14px',
          color: 'var(--grey1)',
        }}
      >
        <HighlightedText query={query} text={employee.email} />
      </div>
    </div>
  </Flex>
)
